import React, { useEffect } from 'react';
import caAPI from "../../services/caAPI";
export default function Auth({ history }) {
    useEffect(() => {
        caAPI.logout();
    }, []);

    return (<></>)
}
